/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class DeleteAlertService {
  constructor(private translateService: TranslateService) {}

  delete(): Promise<any> {
    return new Promise<any>(resolve => {
      this.translateService.get('message.title').subscribe(() => {
        Swal.fire({
          title: this.translateService.instant('AreYouSure'),
          text: this.translateService.instant('WontBeAbleToRevert'),
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: this.translateService.instant('Cancel'),
          confirmButtonColor: '#fdeda1',
          cancelButtonColor: '#000',
          customClass: {
            confirmButton: 'custom-confirm-btn'
          },
          confirmButtonText: this.translateService.instant('DeleteIt')
        }).then((result: any) => {
          return resolve(result);
        });
      });
    });
  }

  unlink(): Promise<any> {
    return new Promise<any>(resolve => {
      this.translateService.get('message.title').subscribe(() => {
        Swal.fire({
          title: this.translateService.instant('AreYouSure'),
          text: this.translateService.instant('WontBeAbleToRevert'),
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: this.translateService.instant('Cancel'),
          confirmButtonColor: '#043146',
          cancelButtonColor: '#000',
          confirmButtonText: this.translateService.instant('Unlink')
        }).then((result: any) => {
          return resolve(result);
        });
      });
    });
  }
}
